import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaLeaf, FaBolt, FaShieldAlt, FaCheckCircle } from 'react-icons/fa';
import './Products.css';

const Products = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="products-page">
      {/* Page Hero */}
      <section className="products-hero">
        <div className="hero-bg">
          <img src="/Home Page images/mountain-bg.jpg" alt="Products Hero" />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="products-hero-content">
            <span className="hero-badge">Our Premium Range</span>
            <h1>Our Products</h1>
            <p>Experience purity in every drop with our packaged drinking water and the freshness of real litchis in our juices.</p>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Our Products</span>
            </div>
          </div>
        </div>
      </section>

      {/* Product Category 1: Packaged Drinking Water */}
      <section id="water" className="product-category-section section">
        <div className="container">
          <div className="category-header">
            <div className="category-label">Hydration</div>
            <h2>Packaged Drinking Water</h2>
            <p>Sourced from pristine aquifers and purified through a rigorous 7-stage process.</p>
          </div>

          <div className="product-display-container">
            <div className="product-main-image">
               <div className="image-backdrop blue"></div>
               {/* Using the image user requested for better visibility, ensure styling makes it big */}
               <img src="/Product Page images/single-water-bottol.png" alt="Shikhar Dhara Water Bottle" />
            </div>
            
            <div className="product-info-panel">
              <h3>Pure & Safe Hydration</h3>
              <p className="description">
                Our packaged drinking water is treated with advanced RO, UV, and Ozonation technology to ensure every sip is safe, sweet, and healthy.
              </p>

              <div className="variants-grid">
                <div className="variant-card">
                  <span className="size">250ml</span>
                  <span className="type">Travel Pack</span>
                </div>
                <div className="variant-card">
                  <span className="size">500ml</span>
                  <span className="type">On-the-go</span>
                </div>
                <div className="variant-card">
                  <span className="size">1 Litre</span>
                  <span className="type">Standard</span>
                </div>
                <div className="variant-card">
                  <span className="size">20 Litre</span>
                  <span className="type">Bulk Jar</span>
                </div>
              </div>

              <div className="product-highlights">
                <div className="highlight">
                  <FaCheckCircle /> 7-Stage Purification
                </div>
                <div className="highlight">
                  <FaCheckCircle /> Added Minerals
                </div>
                <div className="highlight">
                  <FaCheckCircle /> BIS Certified
                </div>
              </div>

              <div className="action-area">
                <Link to="/contact" className="btn btn-primary">Bulk Order Inquiry</Link>
                <Link to="/distributor" className="btn btn-secondary">Become a Distributor</Link>
              </div>
            </div>
          </div>
          
          {/* Quality Standards Strip */}
          <div className="quality-strip mt-4">
             <h3>Our Quality Assurance</h3>
             <div className="quality-icons">
               <div className="q-icon-box">
                  <img src="/logo & badge images/bis-small.png" alt="BIS" />
                  <span>BIS ISI Approved</span>
               </div>
               <div className="q-icon-box">
                  <img src="/logo & badge images/fssai-small.png" alt="FSSAI" />
                  <span>FSSAI Certified</span>
               </div>
               <div className="q-icon-box">
                  <img src="/logo & badge images/iso-small.png" alt="ISO" />
                  <span>ISO 9001:2015</span>
               </div>
             </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="section-divider"></div>

      {/* Product Category 2: Litchi Juice */}
      <section id="juice" className="product-category-section section bg-light">
        <div className="container">
          <div className="category-header">
            <div className="category-label text-green">Refreshment</div>
            <h2>Real Litchi Juice</h2>
            <p>Made from handpicked, luscious litchis from the finest orchards.</p>
          </div>

          <div className="product-display-container reverse">
            <div className="product-main-image">
               <div className="image-backdrop green"></div>
               {/* Using the hero main image as requested */}
               <img src="/Product Page images/fresh-litchi-fruits.jpg" className="rounded-img" alt="Fresh Litchi" />
               <img src="/Home Page images/litchi-juicemain.jpg" className="float-overlay-img" alt="Litchi Juice Bottle" />
            </div>
            
            <div className="product-info-panel">
              <h3>Taste of Real Fruit</h3>
              <p className="description">
                Experience the authentic taste of litchi in every gulp. High fruit content, perfect sweetness, and zero artificial preservatives.
              </p>

              <div className="features-list">
                <div className="feature-item">
                  <span className="f-icon"><FaLeaf /></span>
                  <div className="f-text">
                    <strong>Real Pulp</strong>
                    <small>Contains real fruit pulp</small>
                  </div>
                </div>
                <div className="feature-item">
                  <span className="f-icon"><FaBolt /></span>
                  <div className="f-text">
                    <strong>Energy Boost</strong>
                    <small>Instant energy & refreshment</small>
                  </div>
                </div>
                <div className="feature-item">
                  <span className="f-icon"><FaShieldAlt /></span>
                  <div className="f-text">
                    <strong>Hygienic</strong>
                    <small>Touch-free processing</small>
                  </div>
                </div>
              </div>

              <div className="nutrition-preview">
                <h4>Available Packs</h4>
                 <div className="pack-tags">
                   <span>160ml</span>
                   <span>200ml</span>
                   <span>500ml</span>
                   <span>1 Litre</span>
                 </div>
              </div>

              <div className="action-area">
                <Link to="/contact" className="btn btn-green">Order Juice Stocks</Link>
                <Link to="/distributor" className="btn btn-secondary">Distributorship</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Manufacturing Teaser */}
      <section className="manufacturing-teaser section">
         <div className="container">
            <div className="teaser-content">
               <h2>State-of-the-Art Manufacturing</h2>
               <p>We use fully automatic machines for blowing, filling, and packaging to ensure zero human contact and maximum hygiene.</p>
               <Link to="/manufacturing" className="btn btn-white">View Process</Link>
            </div>
         </div>
      </section>
    </div>
  );
};

export default Products;
